__turbopack_context__.v({
  "fullWidth": "Toolbar-module__vgOQZq__fullWidth",
  "horizontal": "Toolbar-module__vgOQZq__horizontal",
  "toolbar": "Toolbar-module__vgOQZq__toolbar",
  "vertical": "Toolbar-module__vgOQZq__vertical",
});
